// removed by extract-text-webpack-plugin
module.exports = {"bigButton":"_1jXUyexYpuTKs_XuFfo7mJ"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/registrationStudent/registrationStudentForm.scss
// module id = 694
// module chunks = 22